// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
    width: 100%;
}

.hide-container {
    width: 100%;
    margin: 0;
}

.hide-container .title {
    margin: 0 auto 10px;
}

.hide-container form {
    border: 2px solid #f09502;
    padding: 45px;
    color: white;
    background-color: #0e0f15;
}

.hide-container form button {
    display: block;
    max-width: 60%;
    margin: 0 auto;
}

@media (max-width: 500px) {
    .hide-container form {
        padding: 10px;
    }

    .hide-container form button {
        max-width: 100%;
    }
}`, "",{"version":3,"sources":["webpack://./src/app/components/hide-proyect/hide-proyect/hide-proyect.component.css"],"names":[],"mappings":"AAAA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;IACX,SAAS;AACb;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,aAAa;IACb,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,cAAc;IACd,cAAc;AAClB;;AAEA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;AACJ","sourcesContent":[":host {\n    width: 100%;\n}\n\n.hide-container {\n    width: 100%;\n    margin: 0;\n}\n\n.hide-container .title {\n    margin: 0 auto 10px;\n}\n\n.hide-container form {\n    border: 2px solid #f09502;\n    padding: 45px;\n    color: white;\n    background-color: #0e0f15;\n}\n\n.hide-container form button {\n    display: block;\n    max-width: 60%;\n    margin: 0 auto;\n}\n\n@media (max-width: 500px) {\n    .hide-container form {\n        padding: 10px;\n    }\n\n    .hide-container form button {\n        max-width: 100%;\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
